import { RootState } from "store/store";

export const selectWeatherSource = (state: RootState) =>
  state.localState.toggledToAwMetarWeatherSource;

export const selectRunwayName = (state: RootState) => state.localState.selectedRunway?.name;
